module.exports = __webpack_public_path__ + "9a46680f7eecbff42ae91a680cd5be14.svg";